<template lang="pug">
  a(
  v-if="menuItem && menuItem.href"
  :href="menuItem.href"
  target="_blank"
  )
    slot
      span {{$translate(menuItem.title) || ' - '}}
  router-link(
  v-else-if="menuItem"
  :to="{name: menuItem.name, param: menuItem.params || {}, query: menuItem.query || {}}"
  )
    slot
      span {{$translate(menuItem.title) || ' - '}}
</template>

<script>
  export default {
    name: 'menu-link',
    props: {
      menuItem: Object
    }
  }
</script>
